import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, message } from "antd";
import MainLayout from "../../layout/MainLayout";
import { Button1, Button2, QuickActionSelect, TagInput, Select } from "../index";
import plusIcon from "../../assets/icons/plus-circle-white.png";
import uploadIcon from "../../assets/icons/upload-icon.png";
import searchIcon from "../../assets/icons/search-icon.png";
import deleteIcon from "../../assets/icons/trashcan-icon.png";
import plusgreenIcon from "../../assets/icons/plus-icon.png";
import copyIcon from "../../assets/icons/copy-07.png";
import infoIcon from "../../assets/icons/info-icon.png";
import { socialPaymentsApi } from "../../api/endpoints";

const GROUP_TYPES = ["Trip", "Apartment", "Friends", "Family", "Couple", "Other"];
const CATEGORIES = ["Travel", "Food & Drink", "Bills", "Entertainment", "Other"];

const CreateGroup = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [groupType, setGroupType] = useState("");
  const [category, setCategory] = useState("");
  const [members, setMembers] = useState([
    { name: "", email: "" },
    { name: "", email: "" },
  ]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const updateMember = (idx, field, value) => {
    setMembers((prev) =>
      prev.map((m, i) => (i === idx ? { ...m, [field]: value } : m))
    );
  };

  const addMember = () => setMembers((p) => [...p, { name: "", email: "" }]);
  const removeMember = (idx) =>
    setMembers((p) => p.filter((_, i) => i !== idx));

  const handleSave = async (asDraft = false) => {
    setError(null);
    if (!name.trim()) return setError("Group name is required");

    const validMembers = members.filter((m) => m.name.trim() || m.email.trim());
    if (!asDraft && validMembers.length === 0) {
      return setError("Add at least one member");
    }

    setSubmitting(true);
    try {
      await socialPaymentsApi.createGroup({
        name: name.trim(),
        groupType: groupType || null,
        category: category || null,
        members: validMembers.map((m) => ({
          name: m.name.trim(),
          email: m.email.trim(),
        })),
        status: asDraft ? "DRAFT" : "ACTIVE",
      });
      message.success(asDraft ? "Saved as draft" : "Group created");
      navigate("/split-payment");
    } catch (e) {
      setError(e.response?.data?.error || e.message || "Failed to create group");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <MainLayout
        expand={false}
        NavName={"Split Payment"}
        navbarChildren={<QuickActionSelect className="rounded-5" />}
      >
        <div>
          <div className="container mt-5">
            <div className="row">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fs-5 fw-semibold">Create Group</span>
                <QuickActionSelect />
              </div>

              <div className="col-12 px-4 mt-3">
                <div className="row border rounded-3 p-3">
                  <div className="col-lg-6">
                    <div className="d-flex flex-column gap-3 pe-3">
                      <span className="fs-5 fw-semibold">Group Details</span>

                      <div className="d-flex flex-column gap-2">
                        <label className="fs12px">Group Icon</label>
                        <Input
                          placeholder="Upload or drag files here"
                          className="p-3"
                          suffix={<img src={uploadIcon} alt="upload" />}
                        />
                      </div>

                      <div className="d-flex flex-column gap-2">
                        <label className="fs12px">Group Name</label>
                        <Input
                          placeholder="Your group name"
                          className="p-3"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>

                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="fs12px">Group Type</label>
                          <Button2
                            className={"btn-dark py-1 px-3"}
                            icon={<img src={plusIcon} alt="add" />}
                            buttonName={"Add Group Type"}
                            divClassName={"gap-2"}
                          />
                        </div>

                        <Select
                          className="p-3"
                          defaultValue="Select group type"
                          value={groupType}
                          options={GROUP_TYPES.map((t) => ({ name: t, value: t }))}
                          onChange={(e) => setGroupType(e.target.value)}
                        />
                      </div>

                      <div className="d-flex flex-column gap-3">
                        <span className="fs-5 fw-semibold">Additional Details</span>

                        <div className="d-flex flex-column gap-2">
                          <label className="fs12px">Category</label>
                          <Select
                            className="p-3"
                            defaultValue="Choose Category"
                            value={category}
                            options={CATEGORIES.map((c) => ({ name: c, value: c }))}
                            onChange={(e) => setCategory(e.target.value)}
                          />
                        </div>

                        <div className="d-flex flex-column gap-2">
                          <label className="fs12px">Tags</label>
                          <TagInput
                            className="border py-3"
                            inputBgColor="transparent"
                            tagColor="#1bbb6b"
                            tagTextColor="#000"
                            limit={10}
                            placeholder="Add up to 10 Tags"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="d-flex flex-column gap-3 ps-3">
                      <span className="fs-5 fw-semibold">Group Members</span>

                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between gap-5 align-items-center">
                          <label className="fs12px w-50">Name</label>
                          <label className="fs12px w-100">Email</label>
                        </div>
                        {members.map((m, idx) => (
                          <div
                            key={idx}
                            className="d-flex justify-content-between gap-3 align-items-center"
                          >
                            <Input
                              placeholder="Name"
                              className="p-3 w-50"
                              value={m.name}
                              onChange={(e) =>
                                updateMember(idx, "name", e.target.value)
                              }
                            />
                            <Input
                              placeholder="example@gmail.com"
                              className="p-3 w-75"
                              value={m.email}
                              onChange={(e) =>
                                updateMember(idx, "email", e.target.value)
                              }
                              suffix={<img src={searchIcon} alt="search" />}
                            />
                            <div className="align-self-center">
                              <img
                                src={deleteIcon}
                                alt="del"
                                className="cursor-pointer"
                                onClick={() => removeMember(idx)}
                              />
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="d-flex align-items-center justify-content-center cursor-pointer gap-3 p-3 rounded-3"
                        style={{ backgroundColor: "var(--bg-color)" }}
                        onClick={addMember}
                      >
                        <img src={plusgreenIcon} alt="add" />
                        <span
                          className="fs14px fw-semibold"
                          style={{ color: "#1bbb6b" }}
                        >
                          Add Member
                        </span>
                      </div>

                      <div className="d-flex flex-column gap-2">
                        <label className="fs12px">Generate link</label>
                        <Input
                          value={name.trim() ? "Generated after group is created" : ""}
                          placeholder="Generated after group is created"
                          className="p-3"
                          suffix={<img src={copyIcon} alt="copy" />}
                          readOnly
                        />
                        <div className="d-flex align-items-center gap-2">
                          <img src={infoIcon} alt="info" />
                          <span
                            className="fs12px fw-medium"
                            style={{ color: "#7D7D7D" }}
                          >
                            Tips: Lots of people to add? Send your friends the
                            invite link
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {error && (
                    <div className="col-12 mt-3">
                      <span className="fs12px" style={{ color: "#FC555B" }}>
                        {error}
                      </span>
                    </div>
                  )}

                  <div className="d-flex justify-content-end align-items-center gap-3 mt-5">
                    <Button1 buttonName={"Share"} className={"border"} />
                    <Button1
                      buttonName={submitting ? "Saving..." : "Save as Draft"}
                      className={"btn-outline-success"}
                      onClick={() => handleSave(true)}
                      disabled={submitting}
                    />
                    <Button1
                      buttonName={submitting ? "Creating..." : "Create Group"}
                      className={"btn-dark"}
                      onClick={() => handleSave(false)}
                      disabled={submitting}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default CreateGroup;
